import $ from 'jquery';
import Handlebars from 'handlebars';
import MapView from '../views/MapView';
import action from '~/action';
import { addStoreLabels } from '../map/store-labels';
import { addIcons } from '../map/store-icons';
import { addMap } from '../map/map';
import Map from '../models/Map';
import App from '../app';
import Hammer from 'hammerjs';
import svgPanZoom from 'svg-pan-zoom';
import { getStoreById } from '../data-utils';

const ROUTE_PHASE_DELAY = 2000;
const ROUTE_MARK_DELAY = 30;
const MIN_ZOOM = 1;
const MAX_ZOOM = 3;
const PAN_MARGIN = 50;


import * as R from 'ramda';

const PAN_STEP = 30;

var context;

function start(appContext) {
  context = appContext;
  var params = Map.init(context, refresh);
  MapView.render(params);
  bindEvents(params);
  //Hide close button if there is no store selected/no text in search field
  // $('.search-box__reset').toggle(!!params.poi);
  const { showRoute } =  params.poi || {};
  // No dialog needed if show route is on OR user opens route on map from store information page.
  if(params.activeStoreSpace && !showRoute) {
    var maxX = $("#locationMap").width();
    var maxY = $("#locationMap").height() - $(".services").height();
    var {x, y, width, height} = document.getElementById(params.activeStoreSpace).getBoundingClientRect()
    Map.showStoreMenu(params.activeStoreSpace, $("#svgmap").position(), x + width/2 + 46, window.pageYOffset + y + height/2 + 65, maxX, maxY);
    Map.saveState();
    refresh();
  }
}

function refresh(){
  App.resetTimers();
  if(window.location.hash != '#maps') {
    return;
  }

  var params = Map.getMapData(context);
  MapView.render(params);
  bindEvents(params);
  checkRouteGuiding(params);
  checkRouteDots(params);
}

function checkRouteGuiding(params) {
  /* Please note that next route is not shown if the next step is to show routeDots
     checkRouteDots function then calls this function again when it has finished showing the dots
  */
  if(params.playRoute.play && !params.showRouteDots) {

    let currentRoute = {};
    const routes = params.routes;

    // Set current route repending of if this is the first or some other route
    if(typeof params.playRoute.currentRoute.Num != 'undefined') {
      currentRoute = params.playRoute.currentRoute;
    } else {
      currentRoute = routes[0];
      params.playRoute.currentRoute = currentRoute;
      Map.updateGuiding(currentRoute.Num);
      refresh();
      return;
    }

    // We assume that the routes are sorted and the routes are shown in order
    const nextRoute = routes.find(route => {
      return route.Num > currentRoute.Num;
    });

    if(nextRoute) {
      // Don't wait until showing next route if this is the first route
      const delay = params.playRoute.currentRoute ? ROUTE_PHASE_DELAY : 0;

      setTimeout(() => {
        params.playRoute.currentRoute = nextRoute;
        Map.updateGuiding(nextRoute.Num);
        refresh();
      }, delay);
    } else {
      // Show replay button if there are no more routes to show
      params.playRoute.play = false;
      $('#replayroute').animate({
        opacity: 1
      }, 700);
      $('#playRouteOverlay').hide();
    }
  }
}

// This function shows the route dots on map. The function then calls to continue playing the route
function checkRouteDots(params) {
  if(params.showRouteDots){
    $('#route .routemark').css('opacity', 0);
    var circles = $('#route .routemark');
    var delay = ROUTE_MARK_DELAY;
    var maxdelay = (ROUTE_PHASE_DELAY/2) / circles.length;

    if(delay>maxdelay){
      delay = maxdelay;
    }
    circles.each(function(i){
      $(this).delay(delay * i).animate({
        opacity: 1
      }, delay * i);
    });

    params.showRouteDots = false;

    if(params.playRoute.play) {
      setTimeout(() =>  checkRouteGuiding(params), ROUTE_PHASE_DELAY);
    }
  }
}
function showRoute(){
  $('#routesummary').show();
}
function bindEvents(params){

  var storedata = Map.getStoreData(params.floorIndex);
  addMap('#svgmap', params.scimddata.imdFloors, storedata, params.floorId, params.activeStoreSpace, params.imddata.rotation);

  if($('#stores > *').length > 0){
    addStoreLabels('#svgmap__container', '#stores > *', storedata, params.imddata.rotation, params.scid);
  }
  addIcons('#svgmap__container', 'route', params.dots, params.imddata.rotation);
  addIcons('#svgmap__container', 'icons', params.icons, params.imddata.rotation);


  //show service swipe icon only if neccessary
  $('#swipeIcon').hide();
  var servicesWidth = $('.services__container').width();
  var servicesContainerWidth = $('.services').width();
  if(servicesWidth > servicesContainerWidth){
    $('#swipeIcon').show();
  }

  $('#routesummary').hide();
  $('#zoom').hide();
  $('#pan').hide();

  var savedPan = {};
  var savedZoom = 0;

  var onZoom = function(zoom){
    savedZoom = zoom;
    savedPan = this.getPan();
  };

  var onPan = function(pan){
    savedPan = pan;
    savedZoom = this.getZoom();
  };

  var constrain = function(value, min, max) {
    return Math.min(min, Math.max(max, value));
  };

  const minZoom = R.pathOr(
    MIN_ZOOM, ['imdSettings', 'integration', 'inhouse', 'zoom_min'], context
  );
  const maxZoom = R.pathOr(
    MAX_ZOOM, ['imdSettings', 'integration', 'inhouse', 'zoom_max'], context
  );
  const zoomStep = (maxZoom - minZoom) / 3;

  var options = {
    zoomEnabled: true,
    panEnabled: true,
    controlIconsEnabled: false,
    center: false,
    minZoom,
    maxZoom,
    fit: true,
    onZoom: onZoom,
    onPan: onPan,
    dblClickZoomEnabled: false,
    customEventsHandler: {
      haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],

      // Init custom events handler
      init: function(options) {
        var instance = options.instance,
            initialScale = 1,
            pannedX = 0,
            pannedY = 0;

        // Init Hammer
        this.hammer = Hammer(options.svgElement);

        // Enable pinch
        this.hammer.get('pinch').set({enable: !context.disablePinchingZoom});

        // Handle single and double tap
        this.hammer.on('tap', function(ev){
          if(ev.tapCount == 2){
            /* Compensate for rounding errors introduced by SVG Pan and zoom */
            // let newZoomLevel = Math.round(instance.getZoom() + 1);
            let newZoomLevel = instance.getZoom() + zoomStep;

            if (newZoomLevel > maxZoom) {
              newZoomLevel = minZoom;
            }

            const screenScale = App.getStoredData('screenScale', 'all').scale || 1;
            const rect = options.svgElement.getBoundingClientRect();

            const centerX = (ev.center.x - rect.left) / screenScale;
            const centerY = (ev.center.y - rect.top) / screenScale;

            instance.zoomAtPoint(newZoomLevel, {x: centerX, y: centerY});
          }else{
            let target = null;
            if(ev.target.tagName == 'tspan'){
              target = ev.target.parentElement;
            }else if(ev.target.tagName == 'path' || ev.target.tagName == 'text'){
              target = ev.target;
            }else if(ev.target.tagName == 'use'){
              [target] = $(ev.target).closest('g.active');
            }else if(ev.target.tagName == 'tspan'){
              target = $(ev.target).parent();
            }

            if(target != null){
              var id = target.getAttribute('id');
              if(id != null && id != ''){

                var maxX = $('#locationMap').width();
                var maxY = $('#locationMap').height() - $('.services').height();
                var y = window.pageYOffset + ev.center.y;

                saveZoomPan(savedPan, savedZoom);

                const serviceClass = Array.from(target.classList.values())
                  .find(x => /service-\d+/.test(x)) || '';
                const [, serviceid] = serviceClass.split('-');

                if (serviceClass){
                  var iconPosition = $(target).position();
                  var iconWidth = parseFloat($(target).attr('width')) || 48;

                  initialScale = instance.getZoom();

                  var trueIconWidth = iconWidth * initialScale;
                  //middle point of the icon
                  var iconX = iconPosition.left + trueIconWidth/2;
                  var iconY = iconPosition.top + trueIconWidth/2;
                  Map.showServiceLocationMenu(id, serviceid, $('#svgmap').position(), iconX, iconY, maxX, maxY, trueIconWidth);
                }else{
                  Map.showStoreMenu(id, $('#svgmap').position(), ev.center.x, y, maxX, maxY);
                }
                Map.saveState();

                refresh();
              }
            }
          }
        });

        // Handle pinch
        this.hammer.on('pinchstart pinchmove', function(ev){
          // On pinch start remember initial zoom
          if (ev.type === 'pinchstart') {
            initialScale = instance.getZoom();
            instance.zoom(initialScale * ev.scale);
          }
          instance.zoom(initialScale * ev.scale);
        });

        // Prevent moving the page on some devices when panning over SVG
        options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
      },

      // Destroy custom events handler
      destroy: function(){
        this.hammer.destroy();
      }

    },
    beforePan: function(oldPan, newPan) {
      let screenScale = App.getStoredData('screenScale', 'all').scale || 1;

      const sizes = this.getSizes();
      sizes.screen = {
        width: sizes.width / screenScale,
        height: sizes.height / screenScale,
        scale: screenScale
      };
      sizes.map = {
        x: sizes.realZoom * sizes.viewBox.x,
        y: sizes.realZoom * sizes.viewBox.y,
        width: sizes.realZoom * sizes.viewBox.width,
        height: sizes.realZoom * sizes.viewBox.height,
      };

      const SCALED_MARGIN = PAN_MARGIN * sizes.realZoom;
      let customPan = {};

      const lowX = -1 * sizes.map.x + SCALED_MARGIN;
      const hiX = lowX + (sizes.screen.width - sizes.map.width) - SCALED_MARGIN * 2;

      const lowY = -1 * sizes.map.y + SCALED_MARGIN;
      const hiY = lowY + (sizes.screen.height - sizes.map.height) - SCALED_MARGIN * 2;

      if (sizes.map.width > sizes.screen.width) {
        customPan.x = constrain(newPan.x, lowX, hiX);
      } else {
        customPan.x = constrain(newPan.x, hiX, lowX);
      }

      if (sizes.map.height > sizes.screen.height) {
        customPan.y = constrain(newPan.y, lowY, hiY);
      } else {
        customPan.y = constrain(newPan.y, hiY, lowY);
      }

      if (context.debugPan) {
        updateDebugPanPanel(sizes, customPan, {lowX, hiX, lowY, hiY});
      }

      return customPan;
    }
  };

  function updateDebugPanPanel(sizes, pan, constraints) {
    const fix = (n, k, obj) => {
      if (typeof n == 'number') obj[k] =n.toFixed(2);
    };
    sizes = R.forEachObjIndexed(fix, sizes);
    sizes.screen = R.forEachObjIndexed(fix, sizes.screen);
    sizes.viewBox = R.forEachObjIndexed(fix, sizes.viewBox);
    sizes.map = R.forEachObjIndexed(fix, sizes.map);
    pan = R.forEachObjIndexed(fix, pan);
    constraints = R.forEachObjIndexed(fix, constraints);
    const panel = Handlebars.partials['map.inhouse.debug']({sizes, pan, constraints})
    $('#debug-pan-panel').html(panel);
  }

  var panZoom = svgPanZoom('#svgmap', options);

  //set default position
  panZoom.center();
  panZoom.zoom(1);


  //zoom to route
  if(!$.isEmptyObject(params.routes)){
    if(!$.isEmptyObject(params.currentRoute)){
      if(params.svgZoom!=''){
        panZoom.zoom(params.svgZoom);
      }
      if(!$.isEmptyObject(params.svgPan)){
        panZoom.pan(params.svgPan);
      }

      var customPan = getNewCoordinates(params.currentRoute.MiddlePoint, params.imddata.rotation);
      var newCustomPan = {x: $('#svgmap').width()/2 - customPan.x, y: $('#svgmap').height()/2 - customPan.y};
      var customZoom = 1;
      saveZoomPan(newCustomPan, customZoom);
      panZoom.pan(newCustomPan);
      panZoom.zoom(customZoom);
    }else{
      // If showing routes but currentRoute is not defined, then pan to IMD
      panToImd();
    }
  }

  //zoom to closest service
  else if(!$.isEmptyObject(params.closestService)){
    var customPan = getNewCoordinates(params.closestService.pinLocation, params.imddata.rotation);
    var newCustomPan = {x: $('#svgmap').width()/2 - customPan.x, y: $('#svgmap').height()/2 - customPan.y};
    panZoom.pan(newCustomPan);
    panZoom.zoom(1);
  }

  //zoom to active area
  else if(!$.isEmptyObject(params.zoomArea)){
    var customPan = getNewCoordinates(params.zoomArea.middlePoint, params.imddata.rotation);
    var newCustomPan = {x: $('#svgmap').width()/2 - customPan.x, y: $('#svgmap').height()/2 - customPan.y};
    panZoom.pan(newCustomPan);
    panZoom.zoom(1);
  }

  //zoom to saved position
  else if(!$.isEmptyObject(params.svgPan) && params.svgZoom!=''){
    if(params.svgZoom!=''){
      panZoom.zoom(params.svgZoom);
    }
    if(!$.isEmptyObject(params.svgPan)){
      panZoom.pan(params.svgPan);
    }
  }

  //pan to imd
  else if(params.floorIndex==params.imddata.floorIndex){
    panToImd();
  }


  function panToImd() {
    var customPan = getNewCoordinates({x: params.imddata.x, y: params.imddata.y}, params.imddata.rotation);
    var newCustomPan = {x: $('#svgmap').width()/2 - customPan.x, y: $('#svgmap').height()/2 - customPan.y};
    panZoom.pan(newCustomPan);
    panZoom.zoom(1);
  }

  $('.service').click(function(){
    const activeServiceType = params.activeServiceType;
    Map.saveState();
    Map.clear();
    Map.toggleService(activeServiceType, this.id);
    saveZoomPan(savedPan, savedZoom);
    refresh();
  });
  $('#storemenu .info').click(function(){
    Map.goToStore(this.id);
    const store = getStoreById(this.id);
    const currentStore = { store, showRoute: false };
    App.saveLocally(currentStore, 'currentStore', 'all');
  });
  $('#storemenu .route').click(function(){
    Map.showRouteToStore(this.id);
    refresh();
  });
  $('#servicemenu .location').click(function(){
    Map.locateService(this.id);
    refresh();
  });
  $('#servicemenu .route').click(function(){
    Map.clear();
    Map.showRouteToServiceId(this.id);
    refresh();
  });
  $('#servicemenuModal .location').click(function(){
    Map.locateService(this.id);
    refresh();
  });
  $('#servicemenuModal .route').click(function(){
    Map.clear();
    Map.showRouteToServiceId(this.id);
    refresh();
  });
  $('#serviceLocationMenu .route').click(function(){
    console.log($('use.highlight').attr('id'));
    var location = $('use.highlight').attr('id');
    Map.showRouteToThisServiceId(this.id, location);
    refresh();
  });
  $('.sidebar .list-floor-element').click(function(){
    if(this.id != params.floorId){
      saveZoomPan(savedPan, savedZoom);
      Map.setFloor(this.id);
      refresh();
    }
  });
  $('#backbutton').on('click', function(){
    var doRefresh = Map.goBack();
    if(doRefresh){
      refresh();
    }
  });
  $('.zoom-controls').click(function(){
    $('#zoom').show();
    $('#pan').hide();
  });
  $('.pan-controls').click(function(){
    $('#pan').show();
    $('#zoom').hide();
  });
  $('#zoom-in').click(function(){
    // var currentPan = panZoom.getPan();
    panZoom.zoomIn();
  });
  $('#zoom-out').click(function(){
    // var currentPan = panZoom.getPan();
    panZoom.zoomOut();
  });
  $('#pan-top').click(function(){
    var currentPan = panZoom.getPan();
    panZoom.pan({x: currentPan.x, y: currentPan.y - PAN_STEP});
  });
  $('#pan-down').click(function(){
    var currentPan = panZoom.getPan();
    panZoom.pan({x: currentPan.x, y: currentPan.y + PAN_STEP});
  });
  $('#pan-left').click(function(){
    var currentPan = panZoom.getPan();
    panZoom.pan({x: currentPan.x - PAN_STEP, y: currentPan.y});
  });
  $('#pan-right').click(function(){
    var currentPan = panZoom.getPan();
    panZoom.pan({x: currentPan.x + PAN_STEP, y: currentPan.y});
  });
  $('.next-phase').click(function(){
    Map.updateGuiding(this.id);
    refresh();
    $('#replayroute').css('opacity', 1);
  });
  $('.sidebar .route-summary__close').click(function(){
    $('#replayroute').hide();
    Map.clear();
    saveZoomPan(savedPan, savedZoom);
    refresh();
  });
  $('#routesummary .show-again').click(function(){
    Map.showGuidingAgain();
    saveZoomPan(savedPan, savedZoom);
    refresh();
  });

  $('#replayroute').click(function() {
    Map.showGuidingAgain();
    refresh();
  });

  $('.overlay').click(function(e){
    e.stopPropagation();
    Map.clear();
    saveZoomPan(savedPan, savedZoom);
    refresh();
  });

  $('#playRouteOverlay').click((e) => {
    // Disable everything while playing route
    e.stopPropagation();
  });

  $('.search-box__input, .search-box__submit').click(() =>
    action.searchMapFeatures()
  );

  // $('.search-box__reset').click(() =>
  //   action.searchMapFeatures(true)
  // );

  $(document).on('click', '#homebutton', function () {
    App.goTo('start');
  });
}

function saveZoomPan(pan, zoom){
  Map.savePan(pan);
  Map.saveZoom(zoom);
  Map.updateState();
}

function getNewCoordinates(point, angle) {

  var radians = (Math.PI / 180) * angle,
      cos = Math.cos(radians),
      sin = Math.sin(radians),
      ny = point.y*cos + point.x*sin,
      nx = -point.y*sin + point.x*cos;


  return {x: nx, y: ny};
}

export default {
  start,
  refresh,
  bindEvents
};
